import { LitElement, html, css } from 'lit';

export const ELEMENTS = {
  container: { id: 'skeleton-container' },
  lines: { selector: '.skeleton-line' },
  skeletonLine: { selector: '[id^=skeleton-line-]' },
};

class NebSkeleton extends LitElement {
  static get properties() {
    return {
      lines: { type: Number },
    };
  }

  constructor() {
    super();
    this.initState();
  }

  initState() {
    this.lines = 4;
  }

  static get styles() {
    return [
      css`
        .skeleton-container {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .skeleton-line {
          height: 16px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          border-radius: 4px;
          animation: skeleton-loading 1.5s infinite;
        }

        .skeleton-line:first-child {
          width: 80%;
        }

        .skeleton-line:nth-child(2) {
          width: 60%;
        }

        .skeleton-line:nth-child(3) {
          width: 90%;
        }

        .skeleton-line:last-child {
          width: 70%;
        }

        @keyframes skeleton-loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `,
    ];
  }

  render() {
    return this.lines > 0
      ? html`
          <div id="${ELEMENTS.container.id}" class="skeleton-container">
            ${Array(this.lines)
              .fill()
              .map(
                (_, index) =>
                  html`<div
                    id="skeleton-line-${index}"
                    class="skeleton-line"
                  ></div>`,
              )}
          </div>
        `
      : '';
  }
}

window.customElements.define('neb-skeleton', NebSkeleton);
